// extracted by mini-css-extract-plugin
module.exports = {"form":"_19D4Y","mainContainer":"_3Zuqt","text":"_2_eD8","lastButton":"_1VSD4"};